import type { Play } from "../types";

const INDEX_KEY = "basketball-playbook:drafts";

export interface DraftIndexEntry {
  id: string;
  name: string;
  updatedAt: string;
}

export function loadAllDrafts(): Play[] {
  return listDrafts().map((entry) => loadDraft(entry.id)).filter((play): play is Play => Boolean(play));
}

function playKey(id: string) {
  return `basketball-playbook:draft:${id}`;
}

export function saveDraft(play: Play) {
  localStorage.setItem(playKey(play.id), JSON.stringify(play));
  const index = listDrafts().filter((entry) => entry.id !== play.id);
  index.unshift({ id: play.id, name: play.name, updatedAt: new Date().toISOString() });
  localStorage.setItem(INDEX_KEY, JSON.stringify(index.slice(0, 20)));
}

export function loadDraft(id: string): Play | null {
  try {
    const value = localStorage.getItem(playKey(id));
    return value ? (JSON.parse(value) as Play) : null;
  } catch {
    return null;
  }
}

export function removeDraft(id: string) {
  localStorage.removeItem(playKey(id));
  localStorage.setItem(INDEX_KEY, JSON.stringify(listDrafts().filter((entry) => entry.id !== id)));
}

export function listDrafts(): DraftIndexEntry[] {
  try {
    return JSON.parse(localStorage.getItem(INDEX_KEY) ?? "[]") as DraftIndexEntry[];
  } catch {
    return [];
  }
}
